<template>
  <div class="layout-frame antialiased text-zinc-900 dark:text-slate-300" :class="'openSidebar_'+openSidebar">
    <div class="layout-shell">
      <sidebar :dataOpenSideBar="openSidebar"/>
      <div class="w-full h-full in_body">
        <headerTop :dataOpenSideBar="openSidebar" :isLoading="isLoading" :clickHambuger="toggleSidebar" :username="username" class="in_head"/>
        <div class="in_content_view">
          <div class=" w-full in_content">
            <Toast class="toastt_p mt-10" position="top-center" />
            <Toast class="toastt_p mt-10" position="top-right" group="topr" />
            <Toast class="toastt_p mt-10" position="top-left" group="topl" />
            <Toast class="toastt_p" position="bottom-left" group="botl" />
            <Toast class="toastt_p" position="bottom-right" group="botr" />
            <Toast class="toastt_p" position="bottom-center" group="botc" />

          <router-view  :isLoading="isLoading" @update-loading="updateLoading" @showMusicPlayer="showMusicPlayer" @showVideoPlayer="showVideoPlayer"> </router-view>
          
          <div class="card flex justify-content-center">
              <Dialog v-model:visible="musicPlayerVisible" :header="musicPlayerHeader" class="musicModal" position="bottom">
                  <!-- <audio ref="audioPlayer" controls class="musicModalAudio" style="">
                    <source :src="musicPlayerSRC" type="audio/mpeg">
                    Tu navegador no soporta este elemento de Audio.
                  </audio> -->
                  <small class="musicPlayerArtist">{{ musicPlayerArtist }}</small>
                  <div ref="audioContainer"></div>
              </Dialog>
          </div>
          <br /><br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import headerTop from '@/components/header.vue'
  import sidebar from '@/components/sidebar.vue'

  export default {
    components: { headerTop, sidebar },
    data() {
      return {
        openSidebar: true,
        isLoading: false,
        musicPlayerVisible: false,
        musicPlayerSRC:'',
        musicPlayerHeader: 'Music Player',
        audioPlayer: null,
        audioContainer: null,
        musicPlayerArtist: '',
      }
    },
    methods: {
      toggleSidebar() {
        this.openSidebar = !this.openSidebar
      },
      updateLoading(value) {
        this.isLoading = value;
      },
      showMusicPlayer(value, songName, artist) {
        try {
          
          this.musicPlayerVisible = true;
          setTimeout(() => {
          this.audioContainer = this.$refs.audioContainer;
          if (this.audioPlayer) {
            this.audioPlayer.pause();
          }
          this.audioContainer.innerHTML = '';
          this.musicPlayerSRC = value;
          this.musicPlayerHeader = songName;
          this.musicPlayerArtist = artist;
          this.audioPlayer = document.createElement('audio');
          this.audioPlayer.setAttribute('src', this.musicPlayerSRC);
          this.audioPlayer.setAttribute('controls', '');
          this.audioPlayer.setAttribute('class', 'musicModalAudio');
          this.audioPlayer.addEventListener('error', () => {
            console.log('Error al reproducir el audio');
            this.audioPlayer.pause();
            this.audioPlayer.currentTime = 0;
            this.audioPlayer.removeAttribute('src');
            this.audioPlayer.load();
            this.audioPlayer.play();
            this.$toast.add({ severity: 'error', summary: 'Error en archivo de Audio', detail: 'Archivo no encontrado', group: 'topr', life: 3000 });
          });

          this.audioContainer.appendChild(this.audioPlayer);
          this.audioPlayer.load();
          this.audioPlayer.play(); 
          }, 300);
           

        } catch (error) {
          console.log(':::::::::::Error al reproducir el audio');
          console.log(error); 
          console.log(':::::::::::Error al reproducir el audio');
          console.log(this.audioPlayer.error);
          console.log(':::::::::::Error al reproducir el audio');
        }
      },
      showVideoPlayer(value, songName, artist) {
        this.musicPlayerVisible = true;
        setTimeout(() => {
          this.audioContainer = this.$refs.audioContainer;
          if (this.audioPlayer) {
            this.audioPlayer.pause();
          }
          this.audioContainer.innerHTML = '';
          this.musicPlayerSRC = value;
          this.musicPlayerHeader = songName;
          this.musicPlayerArtist = artist;
          this.audioPlayer = document.createElement('video');
          this.audioPlayer.setAttribute('src', this.musicPlayerSRC);
          this.audioPlayer.setAttribute('controls', '');
          this.audioPlayer.setAttribute('class', 'musicModalAudio');
          this.audioContainer.appendChild(this.audioPlayer);
          this.audioPlayer.load();
          this.audioPlayer.play(); 
        }, 300);
      },
    },
    mounted() { 
      if (localStorage.getItem('clientData') === null) {
        this.$router.push({ name: 'login' })
      } else {
        const tokenId = JSON.parse(localStorage.getItem('clientData'))
        if (!tokenId) {
            this.$router.push({ name: 'login' })
        }
      }
      
      
    },
  }
</script>
  
<style>
.layout-frame {
  min-height: 100vh;
  padding: 0;
  background: #eceff3;
}

.dark .layout-frame {
  background: #09090b;
}

.layout-shell {
  --sidebar-open-width: clamp(248px, 22vw, 296px);
  --sidebar-closed-width: 74px;
  --chrome-bg: #f3f4f6;
  --chrome-border: rgba(148, 163, 184, 0.34);
  --canvas-bg: #eceff3;
  --content-bg: #f8fafc;
  --content-border: rgba(148, 163, 184, 0.22);
  --content-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
  background: var(--canvas-bg);
}

.dark .layout-shell {
  --chrome-bg: #18181b;
  --chrome-border: rgba(113, 113, 122, 0.5);
  --canvas-bg: #111113;
  --content-bg: #27272a;
  --content-border: rgba(113, 113, 122, 0.44);
  --content-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
  background: var(--canvas-bg);
}

.openSidebar_true .in_body {
  width: calc(100% - var(--sidebar-open-width));
}
.openSidebar_false .in_body {
  width: calc(100% - var(--sidebar-closed-width));
}

.in_body {
  display: flex;
  flex-direction: column;
}

.in_head {
  flex-shrink: 0;
}

.in_content_view {
  height: calc(100% - 56px);
  overflow: hidden;
  background: var(--canvas-bg);
  padding: 12px;
}

.dark .in_content_view {
  background: var(--canvas-bg);
}

.in_content {
  height: 100%;
  max-width: 100%;
  width: 100%;
  margin: auto;
  overflow: scroll;
  overflow-x: hidden;
  border-radius: 16px;
  border: 1px solid var(--content-border);
  background: var(--content-bg);
  box-shadow: var(--content-shadow);
}

.dark .in_content {
  border-color: var(--content-border);
  background: var(--content-bg);
  box-shadow: var(--content-shadow);
}

.musicModal {
  width:450px;
  max-width: 98%;
}
.musicModalAudio {
  width:100%;
  max-width: 100%;
  background-color: #3b3b3b;
  border-radius: 5px;
}

.musicModal .p-dialog-header{
  padding: 4px 4px 1px 14px !important;
}
.musicModal .p-dialog-header .p-dialog-title{
  font-size: 1rem !important;
}

.musicModal .p-dialog-content {
  padding: 0px 14px 14px 14px !important;
}
.musicPlayerArtist {
  font-size: 0.8rem;
  line-height: 0.8rem;
  font-weight: 300;
  display: block;
  margin-bottom: 10px;
  margin-top: 0px;
}
.toastt_p{
  z-index: 1001;
}
@media (max-width: 1220px) {
  .in_content {
    width: 1100px;
  }
}
@media (max-width: 1120px) {
  .in_content {
    width: 1000px;
  }
}
@media (max-width: 1020px) {
  .in_content {
    width: 940px;
  }
}
@media (max-width: 960px) {
  .in_content_view {
    padding: 8px;
  }

  .in_content {
    width: calc(100% - 20px);
    border-radius: 10px;
  }
}
</style>